@for (item of planningItems; track item; let index = $index) {
    @let previousItem = planningItems[index - 1]?.dayOff ? null : planningItems[index - 1];
    @let gapBefore = previousItem?.enddate | minutesDiff: item.begindate;
    @let changedDate = (item.begindate | date: 'd') !== (planningItems[index - 1]?.begindate | date: 'd');
    @let isNight =
        (changedDate && +(item.begindate | date: 'H') <= 4) ||
        (item.begindate | date: 'yyyy-MM-dd') !== (item.enddate | date: 'yyyy-MM-dd');

    <app-week-schedule-day
        [item]="item"
        [previousItem]="previousItem"
        [nextItem]="planningItems[index + 1]"
        [maxDate]="maxDate"
        [leaveHourtype]="item.hourtype"
        [leaveComment]="item.comment"
        (openItem)="
            item.planning && item.begindate < maxDate && openPlanning(item.planning.id, item.source, item.rowId)
        ">
        @if (item.dayOff || changedDate || gapBefore > 120 || isNight) {
            <div class="day">
                @if (item.dayOff || !isNight) {
                    {{ item.begindate | date: 'EEEE d MMMM' }}
                } @else {
                    <span>Nacht</span> {{ item.enddate | dateSub | date: 'EEE d MMM' }} <span>op</span>
                    {{ item.enddate | date: 'EEE d MMM' }}
                }
            </div>
        }
        @if (!item.dayOff) {
            <div class="time">{{ item.begindate | date: 'HH:mm' }} - {{ item.enddate | date: 'HH:mm' }}</div>
            <div class="project">
                Project {{ item.planning?.afas_project_id }}
                @if (item.planning?.contractor) {
                    - {{ item.planning?.contractor }}
                }
                @if (item.dagrapportStatus) {
                    <span class="badge fs-6" [style.background-color]="'#' + item.dagrapportStatus.color">
                        {{ item.dagrapportStatus.name }}
                    </span>
                }

                <br />
                <b>{{ item.planning?.location_data?.town ?? item.planning?.location ?? '' }}</b>
                <br />

                @if (item.comment) {
                    <i>{{ item.comment }}<br /></i>
                }
                {{ item.planning?.comment }}
            </div>
        } @else if (!item.hourtype) {
            <div class="time dayoff">{{ item.dayOffReason ?? 'niet ingepland' }}</div>
        }
    </app-week-schedule-day>
}
